import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { fadeIn, fadeOut } from '../../js/animation';

const imgURL = '/images';

export default function CoinModalCenter({ setIsModal }: { setIsModal: React.Dispatch<React.SetStateAction<boolean>> }) {
  const [closing, setClosing] = useState<boolean>(false); // 닫힘 애니메이션 적용에 필요

  const closeModal = () => {
    setClosing(true);

    setTimeout(() => {
      setIsModal(false);
      setClosing(false);
    }, 280);
  };

  useEffect(() => {
    document.body.style.overflow = 'hidden';
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, []);

  return (
    <ModalWrap>
      <ModalBox closing={closing}>
        <ModalHeader>
          <ModalTitle>피싱코인 지급 정책</ModalTitle>
          <button className="btn_close" onClick={closeModal}>
            <img src={`${imgURL}/icon_close.png`} alt="닫기" />
          </button>
        </ModalHeader>
        <ModalBody>
          <CoinInfoText>
            <div className="inner_box">
              <strong>피싱코인이란?</strong>
              <p>
                피싱코인은 낚시인들에게 도움이 되는 게시글을 작성해주시는 분들께 지급되는 어바웃피싱 내의 가상
                재화입니다. <br />
                획득 타입 별 보상은 아래 표와 같습니다.
              </p>
              <table>
                <colgroup>
                  <col width={'20%'} />
                  <col width={'20%'} />
                  <col width={'20%'} />
                  <col width={'20%'} />
                  <col width={'20%'} />
                </colgroup>
                <thead>
                  <tr>
                    <td>타입</td>
                    <td colSpan={2}>게시글</td>
                    <td>pick</td>
                    <td>명예의 전당</td>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td rowSpan={2}>기록</td>
                    <td>대상어종</td>
                    <td>300c</td>
                    <td rowSpan={5}>3,000c</td>
                    <td rowSpan={2}>10,000c</td>
                  </tr>
                  <tr>
                    <td>손님고기</td>
                    <td>150c</td>
                  </tr>
                  <tr>
                    <td rowSpan={3}>리뷰</td>
                    <td>선박</td>
                    <td>2,000c</td>
                    <td rowSpan={3}>-</td>
                  </tr>
                  <tr>
                    <td>장소</td>
                    <td rowSpan={2}>300c</td>
                  </tr>
                  <tr>
                    <td>장비</td>
                  </tr>
                  <tr>
                    <td>자유게시판</td>
                    <td colSpan={4}>-</td>
                  </tr>
                </tbody>
              </table>
              <strong>피싱코인 활용방법</strong>
              <p>
                피싱코인은 어바웃피싱 내 각종 챌린지 및 이벤트에 참여 하는데 사용할 수 있으며 '적립금' 변경 후 샵에서
                할인받 을 수 있습니다.
              </p>
              <ul>
                <li>챌린지/이벤트: 어바웃피싱에서 피싱코인을 통해 참여 가능한 챌린지/이벤트</li>
                <li>
                  샵: 보유한 피싱코인을 적립금으로 전환하여 유명 브랜드 및 제품을 최대 10%까지 적립금을 사용해 구매 할
                  수 있는 샵
                </li>
              </ul>
              <strong>피싱코인 적립절차</strong>
              <p>
                피싱코인은 기록(조과), 리뷰 게시물을 등록하시면 관리자 의 검수 후 지급되며, 지급된 모든 피싱코인은
                코인내역에서 확인 가능합니다. 피싱코인 지급 절차는 아래와 같습니다.
              </p>
              <ul>
                <li>기록(조과), 리뷰 작성: 작성 즉시 '적립예정' 코인 발생</li>
                <li>관리자 1차 검수: 피싱코인을 지급하기 적합한 게시물인지 검수하여 상단 획득 타입 별 보상을 지급</li>
                <li>관리자 2차 검수: 관리자가 pick 선정하여 3,000 피싱코인을 추가 지급(기록에만 해당)</li>
              </ul>
              <strong>피싱코인 지급기준</strong>
              <p>
                다른 낚시인들에게 보다 정확한 정보를 제공하고 데이터로서의 가치 여부에 따라 피싱코인 지급이 결정되며,
                검수 기준은 다음과 같습니다.
              </p>
              <strong>1&#41; 1차 검수 기준(코인 지급 기준)</strong>
              <ul>
                <li>사진의 어종과 등록된 어종의 일치 여부 판단(어종 식별이 가능하도록 촬영 필요)</li>
                <li>
                  낚시에 의한 결과 여부 판단(사진의 배경 혹은 환경이 실제 낚시를 증명할 수 있는지 판단하며 장소 파악이
                  불가능한 아이스박스, 바닥 등은 지양 필요)
                </li>
                <li>낚시 가능 지역에서의 조과 판단(낚시 금지 구역, 주거지, 관리되는 연못 등 불가)</li>
                <li>낚시 관련 준법 여부 판단(금어기, 금지체장, 환경 정책 준수 등 위법 시 불가)</li>
                <li>데이터의 신뢰성 판단(허위, 비윤리적, 무의미한 반복 게시 등에 대한 불가)</li>
              </ul>
              <strong>2&#41; 2차 검수 기준(pick 기준)</strong>
              <ul>
                <li>1차 검수를 통과한 게시물 중 대표사진, 글, 꿀팁 등 데이터 측면의 게시물 완성도 판단</li>
                <li>대표사진의 경우, 낚은 물고기를 들고 행복한 웃음과 함께 찍은 사진을 1순위로 판단</li>
              </ul>
              <strong>피싱코인 적립 불가 경우</strong>
              <p>
                다른 낚시인들에게 보다 정확하고 다양한 정보를 제공하기 위해 아래와 같은 경우 피싱코인이 지급되지
                않습니다.
              </p>
              <ul>
                <li>
                  어종 모름으로 기록을 등록한 경우, '적립예정' 코인이 발생하지 않으며, 다른 유저들이 추천해준 어종으로
                  게시물의 어종을 업데이트 하는 시점부터 피싱코인 적립 절차가 시작
                </li>
                <li>
                  사진 촬영일 기준 같은 어종을 반복적으로 등록하는 경우, 피드 운영 정책에 따라 제한될 수 있으며, 한 게
                  시물에 사진을 10장까지 첨부 가능하고 마릿수를 적 을 수 있으니 한번에 등록 필요
                </li>
              </ul>
              <strong>피싱코인 회수 경우</strong>
              <p>
                데이터의 신뢰성과 품질성을 유지하기 위해 피싱코인을 지급받은 후 해당 게시글을 삭제하는 경우 지급되었던
                코인 회수됩니다. <br />단 검수 이후 결격사유가 발생한 게시글에 대해서는 관리자 과실로 인정하여 회수되지
                않습니다. <br />
                마지막으로, 기록에서 '적립예정' 코인이 취소되었더라도 상심하지 않으셔도 됩니다. 유해 사유가 발견되어
                삭제된 경우가 아니라면, 게시가 되지 않은 사유를 확인하고 게시글을 수정할 수 있으며 다시 검수 절차를
                진행할 수 있습니다.
              </p>
            </div>
          </CoinInfoText>
        </ModalBody>
      </ModalBox>
      <ModalBackground onClick={closeModal} closing={closing}></ModalBackground>
    </ModalWrap>
  );
}
interface typeProps {
  closing?: boolean;
}

export const ModalBackground = styled.div<typeProps>`
  width: 100%;
  height: 100vh;
  z-index: 20;
  background-color: rgba(0, 0, 0, 0.6);
  position: absolute;
  top: 0;
  left: 0;
  overflow: hidden;
  animation: ${({ closing }) => (closing ? fadeOut : fadeIn)} 0.3s ease-in-out;
`;
export const ModalWrap = styled.div`
  justify-content: center;
  align-items: center;
  display: flex;
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 9999;
  overflow: hidden;
`;
export const ModalBox = styled.div<typeProps>`
  width: 480px;
  height: 540px;
  background-color: var(--colWhite);
  border-radius: 10px;
  animation: ${({ closing }) => (closing ? fadeOut : fadeIn)} 0.3s ease-in-out;
  position: absolute;
  z-index: 30;
  display: flex;
  flex-direction: column;
  gap: 0;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  padding: 0;
`;

export const ModalHeader = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 6px 4px 6px 20px;
  align-items: center;
  & button.btn_close {
    width: 48px;
    height: 48px;
    padding: 12px;
    background: none;
    border: none;
    cursor: pointer;
    img {
      width: 100%;
      height: 100%;
    }
  }
`;

export const ModalBody = styled.div``;

export const ModalFooter = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 12px;
`;

export const ModalTitle = styled.p`
  font-size: 20px;
  font-weight: 600;
  line-height: 24px;
`;

export const CoinInfoText = styled.div<typeProps>`
  background-color: var(--colWhite);
  padding: 0 20px 48px 20px;
  word-break: keep-all;
  z-index: 10;
  width: 100%;
  max-height: 540px;
  overflow-y: scroll;
  border-radius: 0 0 10px 10px;

  & h2 {
    font-size: 20px;
    line-height: 24px;
    color: var(--colBlack);
    font-weight: 600;
    padding: 18px 0;
  }

  & button {
    position: absolute;
    top: 18px;
    right: 16px;
    width: 24px;
    height: 24px;
    background: url('../images/icon_close.png') no-repeat;
    background-size: contain;
    border: 0;
  }

  & .inner_box {
    & strong {
      display: block;
      font-size: 16px;
      line-height: 24px;
      color: var(--colBlack);
      font-weight: 700;
      margin: 24px 0 8px;
      &:nth-child(1) {
        margin-top: 0;
      }
    }
    & p {
      font-size: 16px;
      line-height: 24px;
      color: var(--colBlack);
      font-weight: 400;
    }
    & ul {
      margin-top: 16px;
      list-style: disc;
      padding-left: 20px;
      & li {
        position: relative;
        font-size: 16px;
        line-height: 24px;
        color: var(--colBlack);
      }
    }
    & table {
      width: 100%;
      margin-top: 24px;
      & thead {
        & tr {
          & td {
            padding: 12px 0;
            text-align: center;
            font-size: 11px;
            line-height: 14px;
            color: var(--colBlack);
            font-weight: 600;
            border: 1px solid var(--colGray3);
            background-color: var(--colGray1);
            vertical-align: middle;
          }
        }
      }
      & tbody {
        & tr {
          & td {
            padding: 12px 0;
            text-align: center;
            font-size: 11px;
            line-height: 14px;
            color: var(--colBlack);
            font-weight: 400;
            border: 1px solid var(--colGray3);
            vertical-align: middle;
          }
        }
      }
    }
  }
`;
